
/*
 * FRADIMÉ SIZE GUIDE V3 — PRODUCT DATA
 * Source unit: inches
 * Sizes: XS, S, M, L, XL
 * Use null for measurements not yet confirmed.
 *
 * Add new products here as measurements become available.
 * Zip-Up Hoodie (future product) is intentionally excluded.
 */

(function () {
  "use strict";

  const SIZES = ["XS", "S", "M", "L", "XL"];

  // Each row: [measurement name, XS, S, M, L, XL]
  // The A/B/C measurement codes are assigned in order.

  function product(id, group, name, category, fit, rows, notes = "") {
    return {
      id,
      group,
      name,
      category,
      fit,
      sizes: SIZES,
      measurements: rows.map((row, index) => ({
        code: String.fromCharCode(65 + index),
        label: row[0],
        inches: Object.fromEntries(
          SIZES.filter((size, i) => Number.isFinite(row[i + 1]))
            .map(size => [size, row[SIZES.indexOf(size) + 1]])
        )
      })),
      notes,
      visible: true
    };
  }

  const products = [

    // =========================================
    // WOMEN'S
    // =========================================

    product("bra", "womens", "Bra", "Underwear", "Fitted", [
      ["Bust width laid flat", null, 12, 13, 14, 14.5],
      ["Band width laid flat", null, 12.25, 13, 14, 14.5],
      ["Cup height", null, 7, 7.5, 8, 8.2],
      ["Strap length A", null, 4, 4.5, 4.5, 4.5],
      ["Strap length B", null, 11, 12, 12.5, 13]
    ], "XS not yet measured. Cup shape and support cannot be determined from flat measurements alone."),

    product("thong", "womens", "Thong", "Underwear", "Fitted", [
      ["Waist width laid flat", null, 12.25, 13, 13.75, 14.25],
      ["Front rise", null, 8.5, 9, 9, 9.75],
      ["Back rise", null, 8.5, 9, 9, 9.75],
      ["Gusset width", null, 1.75, 1.75, 1.75, 1.75]
    ], "XS not yet measured."),

    product("leggings", "womens", "Leggings", "Activewear", "Fitted / Compression", [
      ["Waist width laid flat", null, 9.5, 10, 11.5, 12.25],
      ["Hip width laid flat", null, 11.5, 12, 13, 14],
      ["Front rise", null, 9, 9.5, 10, 10.25],
      ["Inside leg", null, 23, 23.5, 24, 24],
      ["Outseam", null, 31.75, 33, 33.5, 34],
      ["Leg opening", null, 3.6, 3.8, 4, 4.25]
    ], "XS not yet measured. Stretch and compression affect the fit."),

    product("sports-bra", "womens", "Sports Bra", "Activewear", "Fitted / Support", [
      ["Bust width laid flat", null, 13, 13.75, 14.5, 15.5],
      ["Band width laid flat", null, 12, 12.75, 13.75, 14.75],
      ["Top to bottom", null, 5.5, 6, 8, 8.75],
      ["Strap length", null, 5, 5.25, 5.5, 5.5]
    ], "XS not yet measured. Support and compression should be considered separately."),

    // Cropped Performance Hoodie will be added when measured.

    // =========================================
    // MEN'S
    // =========================================

    product("boxers", "mens", "Boxers", "Underwear", "Fitted", [
      ["Waist width laid flat", null, 14.25, 14.75, 15.75, 16.25],
      ["Front rise", null, 9.25, 9.75, 10, 10.75],
      ["Inside leg", null, 2.5, 2.5, 2.75, 3],
      ["Outseam", null, 11, 11.25, 11.5, 12.25],
      ["Leg opening", null, 8.75, 9.25, 9.5, 10]
    ], "XS not yet measured. Waistband stretches approximately 1–1.75 inches."),

    product("cargos", "mens", "Cargos", "Trousers", "Relaxed", [
      ["Waist width laid flat", 15, 16.25, 17, 18.5, 19.75],
      ["Hip width laid flat", 20.75, 21.75, 22.75, 23.75, 24.5],
      ["Front rise", 11.25, 11.25, 11.25, 12, 12.5],
      ["Inside leg", 29.25, 30, 31, 32, 32],
      ["Outseam", 40, 41, 42.25, 43.5, 44],
      ["Leg opening", 7.5, 8, 8.5, 9, 9.5]
    ], "Waistband has little or no stretch."),

    product("zip-up-shorts", "mens", "Zip-Up Shorts", "Shorts", "Regular / Relaxed", [
      ["Waist width laid flat", 12.5, 13, 15, 15, 16.5],
      ["Hip width laid flat", 18.5, 19.5, 20.5, 21, 22],
      ["Front rise", 12, 12.5, 12.5, 13.5, 14],
      ["Inside leg", 7.75, 8, 8.75, 9, 9.5],
      ["Outseam", 18.5, 19.25, 20.25, 21.25, 22],
      ["Leg opening", 9.5, 10.25, 10.5, 11.25, 11.75]
    ], "Waistband stretches approximately 1 inch."),

    product("swim-shorts", "mens", "Swim Shorts", "Shorts", "Regular", [
      ["Waist width laid flat", null, 14.5, 15.75, 16.75, 17],
      ["Hip width laid flat", null, 19.25, 20, 21, 21.75],
      ["Front rise", null, 11, 11.5, 12, 12.5],
      ["Inside leg", null, 6.75, 6.75, 7, 7],
      ["Outseam", null, 17, 17.5, 18, 18.25],
      ["Leg opening", null, 11, 11, 11.75, 11.75]
    ], "XS not yet measured. Elasticated waistband stretches approximately 1.75 inches."),

    product("polo-shirt", "mens", "Polo Shirt", "Tops", "Regular", [
      ["Body width (pit to pit)", 19, 19.5, 21, 22.5, 24.25],
      ["Body length", 26.5, 27, 28, 28.5, 28.75],
      ["Shoulder width", 15.75, 16.25, 17, 17.5, 18.5],
      ["Bottom width", 19, 19.25, 21, 22.5, 24.5],
      ["Sleeve length", 8.5, 8.75, 9, 9, 9.5],
      ["Sleeve opening width", 5.25, 5.5, 6, 6.5, 7],
      ["Collar opening width", null, null, null, null, null]
    ], "Collar measurements are still outstanding. Placket length is pending verification."),

    product("cuban-collar-shirt", "mens", "Cuban-Collar Shirt", "Tops", "Relaxed", [
      ["Body width (pit to pit)", 20, 21.25, 22.5, 23.5, 24.25],
      ["Body length", 28.5, 29, 29.5, 30, 30.5],
      ["Shoulder width", 20.75, 22, 22.75, 23.75, 24.5],
      ["Bottom width", 20, 21.25, 22.5, 23.75, 24.5],
      ["Sleeve length", 9, 9.5, 10, 10.5, 11],
      ["Sleeve opening width", 7, 7.5, 8, 8.5, 9],
      ["Collar opening width", null, null, null, null, null],
      ["Front opening length", 28.5, 29, 29.5, 30, 30.5]
    ], "Collar measurements are still outstanding. Front opening length matches body length in the submitted chart."),

    // =========================================
    // UNISEX
    // =========================================

    product("t-shirt", "unisex", "T-Shirts", "Tops", "Oversized", [
      ["Body width (pit to pit)", 22.5, 23.5, 24.5, 25.75, 27],
      ["Body length", 28.25, 29, 29.75, 30.5, 33],
      ["Shoulder width", 22.5, 23.25, 24.25, 25, 26.25],
      ["Bottom width", 22.5, 23.25, 24.5, 25.25, 26.25],
      ["Collar opening width", 5.75, 6, 6, 6.25, 6.25],
      ["Collar opening height", 3, 3, 3, 3, 3],
      ["Collar rib width", 1.25, 1.25, 1.25, 1.25, 1.25],
      ["Sleeve opening width inner", 9, 9.5, 10, 10.5, 11],
      ["Bottom sleeve length", 6.5, 6.5, 6.5, 6.75, 6.75],
      ["Top sleeve length", 8.5, 9, 9.25, 9.5, 10.5],
      ["Sleeve opening width outer", 7, 7.75, 8, 8.75, 9.5],
      ["Sleeve + bottom rib width", 1, 1, 1, 1, 1]
    ], "XS body length corrected to 28.25 inches in the updated measurement sheet."),

    product("400-gsm-hoodie", "unisex", "400 GSM Hoodie", "Hoodies", "Oversized", [
      ["Body width (pit to pit)", 22, 23, 24, 25, 26],
      ["Body length", 27, 28.5, 29.5, 31, 32],
      ["Shoulder width", 23, 24, 25, 26, 27],
      ["Bottom width", 16.5, 17.5, 18.5, 19.5, 20.5],
      ["Arm length", 23, 24, 25, 26, 27],
      ["Arm opening length", 11, 12, 12.5, 13, 14],
      ["Sleeve rib height", 3, 3, 3, 3, 3],
      ["Bottom rib height", 3.5, 3.5, 3.5, 3.5, 3.5],
      ["Bottom sleeve opening width", 3.5, 3.5, 3.75, 4, 4]
    ], "Measurements match the 450 GSM chart supplied. Confirm both use the same fit block before calculating recommendations."),

    product("450-gsm-hoodie", "unisex", "450 GSM Hoodie", "Hoodies", "Oversized", [
      ["Body width (pit to pit)", 22, 23, 24, 25, 26],
      ["Body length", 27, 28.5, 29.5, 31, 32],
      ["Shoulder width", 23, 24, 25, 26, 27],
      ["Bottom width", 16.5, 17.5, 18.5, 19.5, 20.5],
      ["Arm length", 23, 24, 25, 26, 27],
      ["Arm opening length", 11, 12, 12.5, 13, 14],
      ["Sleeve rib height", 3, 3, 3, 3, 3],
      ["Bottom rib height", 3.5, 3.5, 3.5, 3.5, 3.5],
      ["Bottom sleeve opening width", 3.5, 3.5, 3.75, 4, 4]
    ])

  ];

  window.FRADIME_SIZE_DATA = {
    version: 3,
    unit: "in",
    products
  };
})();
